import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import loanFormModel from '../../form_models/loanFormModel';
import * as Yup from 'yup';
import { PrimaryMotivationForSolarOtherRuleset } from '../../business/ruleset/solar_property';

const {
  primaryMotivationForSolarOther,
  primaryMotivationForSolar,
  projectType,
} = loanFormModel.formField;

export class PrimaryMotivationForSolarOtherValidation
  implements ValidationSchema
{
  public name = primaryMotivationForSolarOther.name;
  public label = primaryMotivationForSolarOther.label;
  public type = 'string';
  public dependsOn: string[] = [];

  public required = {
    message: '',
    value: false,
  };

  public nullable = true;
  public ruleset = PrimaryMotivationForSolarOtherRuleset;

  public when(schema: Yup.StringSchema, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('This field is required');

    return schema;
  }
}
export default new Validation(new PrimaryMotivationForSolarOtherValidation());
